import { HeaderGroup as HeaderGroupType } from "react-table";
import { genericMemo } from "../../../../../../utils/genericMemo";
import FooterCell from "./FooterCell";

type FooterGroupProps<T extends object> = { footers: HeaderGroupType<T>[] };

const FooterGroup = genericMemo(
  <T extends object>({ footers, ...restProps }: FooterGroupProps<T>) => {
    return (
      <div {...restProps}>
        {footers.map(column => {
          const { key } = column.getFooterProps();
          return <FooterCell key={key} column={column} />;
        })}
      </div>
    );
  },
);

export default FooterGroup;
